import Evaluator from './evaluator.js'
import Expander from './expander.js'
import Formatter from './formatter.js'
import Serializer from './serializer.js'

export default class Engine {
  constructor (enableCache = false) {
    this.evaluator = new Evaluator(enableCache)
    this.expander = new Expander(enableCache)
    this.formatter = new Formatter(enableCache)
    this.serializer = new Serializer()
  }

  evaluate (formula, data, serialize = false) {
    return this.evaluator.evaluate(formula, data, serialize)
  }

  expand (formula) {
    return this.expander.expand(formula)
  }

  serialize (formula) {
    return this.serializer.serialize(formula)
  }

  format (formula) {
    return this.formatter.format(this.serialize(formula))
  }

  minimize (formula) {
    return this.serializer.serializeNode(this.formatter.parser.parse(this.serialize(formula)))
  }
}
